import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import { retryKyc } from '../../../../../../redux/authentication/actionCreator';
import '../../../../../../pages/Dashboard/components/ErrorDialog/ErrorDialog.scss';
import { Errors } from '../../../../../../static/constants';

function EkycPreError() {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(retryKyc());
  };

  return (
    <Dialog
      open={true}
      className="error-dialog"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="dialog-content">
        <img className="dialog-icon" alt="icon" src="/images/icon-error.svg"></img>
        <p>Sorry something went wrong. Please try again.</p>
        <Button style={{ backgroundColor: '#EA0029' }} variant="contained" className="btn-dialog" onClick={handleClose}>
          OK
        </Button>
      </div>
    </Dialog>
  );
}

export default EkycPreError;
